module.exports = __webpack_public_path__ + "img/card-details.fca02793.png";